// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import PipIndicator, {getDefaultState as getPipIndicatorDefaultState} from './pip-indicator';
import UseAmount, {getDefaultState as getUseAmountDefaultState} from './use-amount';
import t from 'tcomb';

const Product = t.struct({
    baseMachineCode: t.String,
    buildDate: t.maybe(t.Number),
    complianceApplies: t.Boolean,
    customerPrivate: t.Boolean,
    customerSummary: CustomerSummary,
    daysRented: t.Number,
    dealer: Dealer,
    deliveryDate: t.maybe(t.Number),
    description: t.String,
    endUseCode: KeyValuePair,
    expectedDateOfFirstUse: t.maybe(t.Number),
    imageUrl: t.String,
    industryIndicator: t.String,
    invoiceDate: t.maybe(t.Number),
    invoiceNumber: t.String,
    invoicedDealer: Dealer,
    isIrcPin: t.Boolean,
    isNonTracked: t.Boolean,
    jdLinkExpires: t.maybe(t.Number),
    licensePlateNumber: t.String,
    maintenancePlan: t.String,
    make: t.String,
    model: t.String,
    modelYear: t.Number,
    operatingManualIdNumber: t.String,
    otherUnitRequired: t.String,
    pin: t.String,
    pip: t.String,
    pipIndicator: PipIndicator,
    purchaserType: KeyValuePair,
    registrationAllowed: t.String,
    registrationDate: t.maybe(t.Number),
    settlementDate: t.maybe(t.Number),
    status: t.list(KeyValuePair, 'Status'),
    useAmount: UseAmount,
    useAmountAllowedUnits: t.list(KeyValuePair, 'UseAmountAllowedUnits'),
    useAmountLastUpdated: t.maybe(t.Number),
    warranty: t.Boolean
}, {
    name: 'Product',
    strict: true
});

export const getDefaultState = () => new Product({
    baseMachineCode: '',
    buildDate: 0,
    complianceApplies: false,
    customerPrivate: false,
    customerSummary: getCustomerSummaryDefaultState(),
    daysRented: 0,
    dealer: getDealerDefaultState(),
    deliveryDate: 0,
    description: '',
    endUseCode: getKeyValuePairDefaultState(),
    expectedDateOfFirstUse: null,
    imageUrl: '',
    industryIndicator: '',
    invoiceDate: 0,
    invoiceNumber: '',
    invoicedDealer: getDealerDefaultState(),
    isIrcPin: false,
    isNonTracked: false,
    jdLinkExpires: null,
    licensePlateNumber: '',
    maintenancePlan: '',
    make: '',
    model: '',
    modelYear: 0,
    operatingManualIdNumber: '',
    otherUnitRequired: 'N',
    pin: '',
    pip: 'NONE',
    pipIndicator: getPipIndicatorDefaultState(),
    purchaserType: getKeyValuePairDefaultState(),
    registrationAllowed: 'Y',
    registrationDate: null,
    settlementDate: 0,
    status: [getKeyValuePairDefaultState()],
    useAmount: getUseAmountDefaultState(),
    useAmountAllowedUnits: [],
    useAmountLastUpdated: 0,
    warranty: false
});

export default Product;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/product.js